import axios from 'axios';
import { StatusCodes } from 'http-status-codes';
import storage from '../../helpers/storage';
import { StaticRoutes } from '../../Router';
import { OPFBROADCASTCHANNEL, AUTHBROADCASTMESSAGE } from '../../constants/constant.js';
import { isDeepEqual } from '../../helpers';

let authorization = null;
let coreConfig = null;

const STORE_TOKEN_KEY = 'loginState:accessToken';

export const axiosInstance = axios.create();

export const getCoreConfig = async (reinitialise) => {

  if (!coreConfig || !!reinitialise) {

    try {
      const resp = await axios.get('/config.json');
      coreConfig = resp.data;
    } catch (err) {
      console.error('Error occurred while fetching core config', err);
      coreConfig = null;
      throw new Error('GetCoreConfig');
    }
  }

  return coreConfig;
};

axiosInstance.interceptors.request.use(async (cfg) => {

  const coreConfig = await getCoreConfig();

  if (!coreConfig?.opfApiBase) {
    throw new Error('AxiosNoBaseUrl');
  }

  let headers = {
    ...cfg.headers
  };

  const auth = await getAuthorization();

  if (coreConfig?.accessTokenOverride) {
    headers = {
      ...headers,
      Authorization: `Bearer ${coreConfig.accessTokenOverride}`
    };
  } else if (auth && new Date().getTime() <= (auth?.expiry || 0)) {
    headers = {
      ...headers,
      Authorization: `Bearer ${auth.token}`
    };
  }

  return {
    ...cfg,
    baseURL: coreConfig.opfApiBase,
    headers
  };
});

axiosInstance.interceptors.response.use((response) => response, async (err) => {
  const errorStatus = err.status || err.response?.status || StatusCodes.INTERNAL_SERVER_ERROR;
  //Disabling forbidden response as it is not being used and the response body needs to be modified
  //if ([StatusCodes.UNAUTHORIZED, StatusCodes.FORBIDDEN].includes(errorStatus)) {

  const url = err?.config?.url || '';

  const isLogin = url === '/login' || url.includes('/login');

  if ([StatusCodes.UNAUTHORIZED, StatusCodes.FORBIDDEN].includes(errorStatus) && !isLogin) {
    await storage.clear();
    window.location.href = StaticRoutes.login;
    throw new Error('VlUnauthorized');
  }
  throw err;
});

export const getAuthorization = async () => {
  try {
    if (!authorization) {
      const stored = await storage.getItem(STORE_TOKEN_KEY);
      authorization = stored || null;
    }
    return authorization;
  } catch (e) {
    console.warn('get auth failed', e);
    return {};
  }
};
export const setAuthorization = async (auth) => {
  if (!auth) {
    authorization = null;
    await storage.setItem(STORE_TOKEN_KEY, null);
    return null;
  }

  const prev = authorization || {};
  const expiry = auth.timestamp + auth.ttl;
  const next = { ...auth, expiry };

  // ✅ Avoid rewriting if data is the same
  if (isDeepEqual(prev, next)) {
    return prev;
  }

  authorization = next;
  await storage.setItem(STORE_TOKEN_KEY, authorization, authorization?.ttl || 0);
  const channel = new BroadcastChannel(OPFBROADCASTCHANNEL);
  channel.postMessage({ type: AUTHBROADCASTMESSAGE, data: authorization });
  channel.close();
  return authorization;
};

export const getErrorStatus = (err) => err?.status || err?.response?.status || StatusCodes.INTERNAL_SERVER_ERROR;
